import React from 'react';

function About() {
  return (
    <div class="text-4xl" >
    <ul class="flex flex-row">
        <li class="transition duration-500 ease-in-out transform hover:scale-110 px-4">
            <a href="https://www.linkedin.com/in/nidhi-rathee-422442150/">
                <i class="fa fa-linkedin" />
            </a>
        </li>
        <li class="transition duration-500 ease-in-out transform  hover:scale-110 px-4">
            <a href="https://www.instagram.com/nidhi.rathee.art/">
                <i class="fa fa-instagram" />
            </a>
        </li>
        <li class="transition duration-500 ease-in-out transform  hover:scale-110 px-4">
            <a href="https://github.com/NidhiR88">
                <i class="fa fa-github" />
            </a>
        </li>
        <li class="transition duration-500 ease-in-out transform  hover:scale-110 px-4">
            <a href="https://codepen.io/nidhir88">
                <i class="fa fa-codepen" />
            </a>
        </li>
    </ul>

    </div>
  );
}

export default About;
